import PropTypes from 'prop-types'
import { useSetAtom } from 'jotai'
import { globalSettingsAtom, sitesAtom } from '../../lib/atoms'
import { useEffect } from 'react'

export default function StateInitializer({ children, globalSettings, sites }) {
  // 3. Get the setter function for each atom
  const setGlobalSettings = useSetAtom(globalSettingsAtom)
  const setSites = useSetAtom(sitesAtom)

  useEffect(() => {
    setGlobalSettings(globalSettings)
    setSites(sites)
  }, [globalSettings, sites, setGlobalSettings, setSites])

  return <>{children}</>
}

StateInitializer.propTypes = {
  children: PropTypes.node.isRequired,
  globalSettings: PropTypes.shape({
    offices: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    }).isRequired,

    mainMenu: PropTypes.shape({
      nodes: PropTypes.array.isRequired,
    }).isRequired,

    footerMenu: PropTypes.shape({
      nodes: PropTypes.array.isRequired,
    }).isRequired,

    globalOptions: PropTypes.shape({
      acfGlobalOptions: PropTypes.object.isRequired,
    }),
  }).isRequired,
  sites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      units: PropTypes.oneOf(['metric', 'imperial']),
      businessUnit: PropTypes.oneOf(['select', 'modellink']).isRequired,
    })
  ).isRequired,
}
